import { PoolTypography } from '@synergy/components-next';
import { ReactElement, ReactNode } from 'react';
import { SxProps, Theme, styled } from '@mui/material';

const StyledLi = styled('li')(({ theme }) => ({
    textTransform: 'uppercase',

    [theme.breakpoints.up('sm')]: {
        marginBottom: theme.spacing(2),
    },
}));

type FooterColumnTitleProps = {
    sx?: SxProps<Theme>;
    children?: ReactNode;
};

export const FooterColumnTitle = (props: FooterColumnTitleProps): ReactElement => {
    const { sx, children } = props;

    return (
        <StyledLi sx={sx}>
            <PoolTypography variant="subtitle1" component="span">
                {children}
            </PoolTypography>
        </StyledLi>
    );
};
